import React from 'react';
import { ModalContent, ModalFooter } from 'fronton-react';
import { css } from 'linaria';
import { ButtonWithGAClickButton, List, ListItem, ModalHeader, Typography } from 'common/components';
import { CONSTRUCTION_HOUSES_ELEMENT_BLOCK } from '../../../../construction-houses-constants';

const forPrivateList = css`
  && {
    li:not(:last-child) {
      margin-bottom: 8px;

      @media (--only-mobile) {
        margin-bottom: 4px;
      }
    }
  }
`;

export const ForPrivate: React.FC = () => (
  <>
    <ModalHeader title="Бонусы для частных клиентов" />
    <ModalContent>
      <List listStyle="disc" className={forPrivateList}>
        <ListItem>
          <Typography variant="m" size="body_long" adaptive={false}>
            Обновили программу лояльности&nbsp;&mdash; стало ещё выгоднее
          </Typography>
        </ListItem>
        <ListItem>
          <Typography variant="m" size="body_long" adaptive={false}>
            Работаем только с&nbsp;проверенными партнёрами
          </Typography>
        </ListItem>
        <ListItem>
          <Typography variant="m" size="body_long" adaptive={false}>
            Радуем акциями и&nbsp;скидками каждый день
          </Typography>
        </ListItem>
        <ListItem>
          <Typography variant="m" size="body_long" adaptive={false}>
            Предоставляем гарантию на&nbsp;услуги 12&nbsp;месяцев
          </Typography>
        </ListItem>
        <ListItem>
          <Typography variant="m" size="body_long" adaptive={false}>
            Публикуем отзывы только от&nbsp;настоящих покупателей
          </Typography>
        </ListItem>
      </List>
    </ModalContent>
    <ModalFooter>
      <ButtonWithGAClickButton
        elementBlock={CONSTRUCTION_HOUSES_ELEMENT_BLOCK}
        elementName="Подробности"
        elementText="Бонусы для частных клиентов"
        href="/kluch-karta-dom/"
        wide
        variant="outline">
        Подробности
      </ButtonWithGAClickButton>
    </ModalFooter>
  </>
);
